import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../firebase/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { currentUser, loading } = useAuth();

  // ローディング中は何も表示しない（または骨格表示）
  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontSize: '18px',
        color: '#888'
      }}>
        読み込み中...
      </div>
    );
  }

  // ログインしていない場合はstart画面にリダイレクト
  if (!currentUser) {
    return <Navigate to="/start" replace />;
  }

  // ログインしている場合は子コンポーネントを表示
  return children;
};

export default ProtectedRoute;